export const advisorDetailsSelector = (state) => ({
  advisorDetails: state.advisorDetails
});
